import type { UseComboboxStateChangeTypes } from 'downshift';
import { useCombobox } from 'downshift';

import type { IOptions } from '../../../shared/utils/options';

/**
 * Typings
 */

type TUseHoverOption = {
  listOptions: IOptions[];
};

type THandleHoverOption = {
  type: UseComboboxStateChangeTypes;
  highlightedIndex?: number;
  setInputValue: (inputValue: string) => void;
};

/**
 * State Types Permissions
 */

const hoverOptionProhibitedTypes = new Set<UseComboboxStateChangeTypes>([
  useCombobox.stateChangeTypes.ItemMouseMove,
]);

/**
 * Hook
 */

export const useHoverOption = ({ listOptions }: TUseHoverOption) => {
  /**
   * Handlers
   */

  const handleHoverOption = ({ type, highlightedIndex, setInputValue }: THandleHoverOption) => {
    if (!highlightedIndex) return;
    if (hoverOptionProhibitedTypes.has(type)) return;

    if (highlightedIndex >= 0 && highlightedIndex < listOptions.length) {
      setInputValue(listOptions[highlightedIndex].label);
    }
  };

  /**
   * Return
   */

  return { handleHoverOption };
};

export default useHoverOption;
